import { createRouter, createWebHistory } from 'vue-router';
import HomeRoute from './components/HomeRoute.vue';
import ResumeRoute from './components/ResumeRoute.vue';
import ContactRoute from './components/ContactRoute.vue';


const routes = [
  { path: '/', component: HomeRoute },
  { path: '/resume', component: ResumeRoute },
  { path: '/contact', component: ContactRoute },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;